import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import ReviewsModeration from '../components/ReviewsModeration';

export default function Designer() {
  const [items, setItems] = useState([]);
  const [clients, setClients] = useState([]);
  useEffect(() => {
    api.get('/consultations').then(r => setItems(r.data));
    api.get('/clients').then(r => setClients(r.data)).catch(() => {});
  }, []);

  return (
    <main className="bg-stilo-bg min-h-[70vh]" data-testid="designer-page">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-12 pb-32">
        <p className="overline">Studio Stilo · Panel</p>
        <h1 className="font-serif text-5xl mt-2 leading-tight">Tu agenda de hoy.</h1>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-4">
          <section className="lg:col-span-8 border border-stilo-ink/10 bg-white p-6">
            <div className="flex justify-between items-baseline">
              <h2 className="font-serif text-2xl">Asesorías activas</h2>
              <span className="overline">{items.length} totales</span>
            </div>
            <div className="mt-4 divide-y divide-stilo-ink/10">
              {items.length === 0 && <p className="text-stilo-ink3 py-6">Aún no hay asesorías reservadas.</p>}
              {items.map(c => (
                <Link to={`/asesoria/${c.id}`} key={c.id} className="grid grid-cols-12 py-4 hover:bg-stilo-beige px-2 transition-colors" data-testid={`d-consult-${c.id}`}>
                  <div className="col-span-6">
                    <p className="font-serif text-xl">{c.package_name}</p>
                    <p className="text-xs text-stilo-ink3 mt-1">{c.user_email}</p>
                  </div>
                  <div className="col-span-3 self-center"><span className="overline">{c.modality}</span></div>
                  <div className="col-span-3 self-center text-right text-sm text-stilo-ink2">{new Date(c.created_at).toLocaleDateString('es-ES')}</div>
                </Link>
              ))}
            </div>
          </section>

          <aside className="lg:col-span-4 border border-stilo-ink/10 bg-stilo-beige p-6">
            <h2 className="font-serif text-2xl">Clientes</h2>
            <ul className="mt-4 space-y-3">
              {clients.length === 0 && <li className="text-stilo-ink3 text-sm">Aún sin clientes registrados.</li>}
              {clients.map(c => (
                <li key={c.id} className="text-sm">
                  <p className="font-medium text-stilo-ink">{c.name}</p>
                  <p className="text-stilo-ink2 text-xs">{c.email}</p>
                </li>
              ))}
            </ul>
          </aside>
        </div>
        <ReviewsModeration />
      </div>
    </main>
  );
}
